import React from 'react';
import '../styles/AboutPage.css'; // Optional: for styling
import gregPhoto from '../assets/greg.png';
import benPhoto from '../assets/ben.jpg';

const AboutPage: React.FC = () => {
  return (
    <div className="about-page" style={{ padding: '1rem' }}>
      <h2>Meet the Hosts</h2>

      <div className="host-profile">
        <img src={gregPhoto} alt="Greg" className="host-photo" />
        <div>
          <h3>Greg</h3>
          <p>
            Greg is a self-proclaimed rule follower who’s always been fascinated by the rules of professional sports — especially the obscure ones. The idea for <em>That’s A Dumb Rule?</em> sparked in 2021 during an NFL game when Greg found himself yelling at the TV over a questionable call. That moment lit the fuse — and the podcast was born.
          </p>
          <p>
            When he’s not researching rules, Greg enjoys being outside, playing and listening to music, spending time with family, and being a proud grandpa to six amazing grandkids.
          </p>
        </div>
      </div>

      <div className="host-profile">
        <img src={benPhoto} alt="Ben" className="host-photo" />
        <div>
          <h3>Ben</h3>
          <p>
            Ben brings a sharp wit and a fresh perspective to each episode. Whether he’s challenging Greg’s take or diving into the nuance of a rule’s origin, Ben helps keep the conversation lively and insightful. His background in media and love for sports trivia make him the perfect co-host.
          </p>
          <p>
            Outside the podcast, Ben enjoys hiking, live music, and discovering new coffee shops wherever he travels.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;